/*
 * @Author: 陈荣宏 2241220001@qq.com
 * @Date: 2023-04-24 16:12:59
 * @LastEditors: 陈荣宏 2241220001@qq.com
 * @LastEditTime: 2023-04-24 16:42:04
 * @FilePath: \estar-official-web\src\constants\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const baseURL = "http://211.157.180.211:8089";
// export const baseURL = "http://111.206.121.99:8089";
export const imgUrl = "/estar_system/";//首页新闻图片路径
export const newImgUrl = "/estar_system/";//新闻图片路径
export const fileUrl = "/estar_system/";//新闻图片路径